export default __webpack_public_path__ + "static/media/Pregacap-50-eng.a09d4a83.jpg";